/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {WebStorage as ɵb} from './src/utility/storage/cookies-storage';
export {WebStorageUtility as ɵa} from './src/utility/webstorage.utility';